import classNames from "classnames";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import style from "./support.scss";
import { CorporateBundle, SmbBundle } from "components/licenses/bundles";
import bmpSetupStyle from "components/products/bmp-setup.scss";
import { ContactIcon } from "components/products/home-icons/ContactIcon";
import { KnowledgeBaseIcon } from "components/products/home-icons/KnowledgeBaseIcon";
import { SUPPORT_EMAIL } from "domain/globalConstants";
import { CombinedTier } from "domain/tenants";
import { useTheme } from "utils/useTheme";

const Support = (props: { tenantTier: CombinedTier; trialTenant: boolean }): JSX.Element => {
    const theme = useTheme();
    const { t } = useTranslation();
    const history = useHistory();

    return (
        <div className={style.support}>
            <div>
                <div className={style.supportLabel}>{t("Onboarding.home.support")}</div>
                <div className={style.needHelp}>{t("Onboarding.home.needHelp")}</div>
            </div>
            <div className={classNames(style.item, bmpSetupStyle.linkText)}>
                <KnowledgeBaseIcon color={theme.iconFillColor} />
                <button onClick={() => history.push("/knowledge-base")} className={style.strongButton}>
                    {t("Onboarding.home.knowledgeBase")}
                </button>
            </div>
            {Object.keys(SmbBundle).includes(props.tenantTier) ||
                props.tenantTier === CorporateBundle.STARTER.valueOf() || (
                    <>
                        <div className={style.spacer}></div>
                        <div className={classNames(style.item, bmpSetupStyle.linkText)}>
                            <ContactIcon color={theme.iconFillColor} />
                            <button
                                onClick={() => (props.trialTenant ? launchEmailSend() : launchSupportPage())}
                                className={style.strongButton}
                            >
                                {t("Onboarding.home.contactSupport")}
                            </button>
                        </div>
                    </>
                )}
        </div>
    );

    function launchSupportPage() {
        window.open(
            "https://portal.servicedesk.blancco.com/servicedesk/customer/user/login?destination=portals",
            "_blank"
        );
    }

    function launchEmailSend() {
        const emailSubject = encodeURIComponent(t("Common.trialSupportEmailSubject"));
        const emailBody = encodeURIComponent(t("Common.trialSupportEmailBody"));
        window.open(`mailto:${SUPPORT_EMAIL}?subject=${emailSubject}&body=${emailBody}`);
    }
};

export default Support;
